<div style="margin: 10px;">

	<hudu-export-config [Network]="Network" [HuduExport]="HuduExport" [Agent]="Agent" [ScheduledDiscovery]="Discovery"
						[EnableExportOrigin]="true"></hudu-export-config>

</div>
